import(/* webpackMode: "eager" */ "/home/runner/work/kst-frontend/kst-frontend/app/buynow-customer-campaign/page.tsx")